module.exports = __webpack_public_path__ + "src/assets/textures/env/metal_tray/metal_tray_512_bake.png";